import { useEffect, useState, useCallback } from "react";
import { useAuth } from "../../../components/context/LoginContext/AuthContext";

export const useGetAgreementById = (agreementId) => {
  const { user, fetchWithAuth } = useAuth();
  const apiUrl = process.env.REACT_APP_API_URL;

  const [agreement, setAgreement] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchAgreement = useCallback(async () => {
    if (!user?.token || !agreementId) return;

    setLoading(true);
    try {
      const res = await fetchWithAuth(
        `${apiUrl}/school/agreement/edit/${agreementId}`,
        { method: "GET" }
      );

      const result = await res.json();
      if (!result.success) throw new Error(result.message);

      setAgreement(result.data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [apiUrl, fetchWithAuth, user, agreementId]);

  useEffect(() => {
    fetchAgreement();
  }, [fetchAgreement]);

  return { agreement, loading, error };
};
